import axios from "axios";
import makeQueryString from "shared/functions/make-query-string";

const ENDPOINT = "/system-log";

export const searchSystemLog = (formData: any) => {
	const string = makeQueryString(formData);
	return axios.get(`${ENDPOINT}?${string}`);
};

export const getSystemModules = () => axios.get("/system-log/modules");

export const sysLogAuthentication = (password: string) =>
	axios.post("/task", { password: password });
